module.exports = __webpack_public_path__ + "assets/general-white.64be5aa0.svg";